/**
 * Policy constants
 */

export const POLICY_TYPES = [
  { value: 'terms_and_conditions', label: 'Terms and Conditions' },
  { value: 'privacy_policy', label: 'Privacy Policy' },
  { value: 'child_policy', label: 'Child Policy' },
  { value: 'cancellation_policy', label: 'Cancellation Policy' },
  { value: 'refund_policy', label: 'Refund Policy' },
  { value: 'check_in_policy', label: 'Check-in Policy' },
  { value: 'check_out_policy', label: 'Check-out Policy' },
  { value: 'pet_policy', label: 'Pet Policy' },
  { value: 'smoking_policy', label: 'Smoking Policy' },
  { value: 'age_restriction_policy', label: 'Age Restriction Policy' },
];

export const THEME_COLOR = '#4ce1b6';

